module.exports = __webpack_public_path__ + "media/images/img_plus-sem-7a286c3bcfd05dbb87642ad848e27213.png";